module.exports = __webpack_public_path__ + "img/icon_sign.eda32176.png";